export default "__VITE_ASSET__425d7a16__"